var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#334155",
    width: "48px",
    height: "48px",
    viewBox: "0 0 30.72 30.72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "share") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1 27.84Q21.42 27.84 20.34 26.7 19.2 25.56 19.2 23.94 19.2 23.4 19.26 23.28L10.26 18.18Q9.24 19.2 7.74 19.2 6.12 19.2 4.98 18.06 3.84 16.92 3.84 15.3 3.84 13.74 4.98 12.66 6.12 11.52 7.74 11.52 9.24 11.52 10.26 12.54L19.26 7.5Q19.2 7.32 19.2 6.66 19.2 5.1 20.34 4.02 21.42 2.88 23.04 2.88 24.6 2.88 25.74 4.02 26.82 5.1 26.88 6.66 26.88 8.28 25.74 9.42 24.6 10.56 23.04 10.56 21.66 10.56 20.46 9.54L11.46 14.64Q11.52 14.76 11.52 15.3 11.52 15.9 11.46 16.08L20.46 21.18Q21.66 20.16 23.1 20.16 24.9 20.16 25.86 21.3 26.82 22.44 26.82 24 26.82 25.56 25.86 26.7 24.9 27.84 23.1 27.84Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.8bd6312fec2c1c4f434ff7e8e27df0e5.svg";
export { ForwardRef as ReactComponent };